.root {
	background-color: var(--ds-background-neutral, var(--adg3-color-N10));
	border-left: 1px solid var(--ds-border, var(--adg3-color-N50));
	flex: 1;
	overflow: auto;
	padding: calc(var(--jpo-common-base-spacing) * 2);
}

.section {
	margin-top: var(--jpo-common-base-spacing);

	&:first-child {
		margin-top: 0;
	}
}
